import {
  PaymentFailedContainer,
  ImageContainer,
  ImageAndDetailsContainer,
  DetailsContainer,
  Heading,
  Subheading,
  CTAContainer,
  StyledButton,
  HelpNeededHeadingContainer,
  HelpNeededHeading,
  HelpNeededContainer,
  HelpNeededSubHeading,
  HelpNeededCTA
} from "./payment-failed.styles";
import Image from "next/legacy/image";
import PaymentErrorFailedImage from "public/assets/payment-error-failed.png";
import { IPaymentFailedProps } from "./payment-failed.types";
import { Callout } from "components/icons/callout";
import { Arrow } from "components/icons/arrow";
const PaymentFailed: React.FC<IPaymentFailedProps> = ({
  subheading = "CoLearn belum terima danamu. Silakan coba lagi, ya.",
  isCTAVisible = false,
  layout = "normal",
  isHelpNeededSectionVisible,
  onCTAClickAction,
  onChatClickAction
}) => {
  return (
    <PaymentFailedContainer layout={layout}>
      <ImageAndDetailsContainer>
        <ImageContainer>
          <Image
            height="220"
            width="220"
            layout="responsive"
            alt="payment-failed"
            src={PaymentErrorFailedImage}
          ></Image>
        </ImageContainer>
        <DetailsContainer>
          <Heading>Pembayaran nggak berhasil</Heading>
          <Subheading>{subheading}</Subheading>
        </DetailsContainer>
      </ImageAndDetailsContainer>
      {isCTAVisible && (
        <CTAContainer>
          <StyledButton onClick={onCTAClickAction} variant="primary">
            Coba lagi
          </StyledButton>
        </CTAContainer>
      )}
      {isHelpNeededSectionVisible && (
        <HelpNeededContainer>
          <HelpNeededHeadingContainer>
            <Callout /> <HelpNeededHeading>Butuh Bantuan?</HelpNeededHeading>
          </HelpNeededHeadingContainer>
          <HelpNeededSubHeading>
            Hubungi Academic Counsellor aja.
          </HelpNeededSubHeading>
          <HelpNeededCTA onClick={onChatClickAction}>
            Ngobrol lewat Whatsapp <Arrow />
          </HelpNeededCTA>
        </HelpNeededContainer>
      )}
    </PaymentFailedContainer>
  );
};

export { PaymentFailed };
